
import * as reducer from './reducers';

import * as authTypes from './types';
import * as authActions from './actions';
import * as authEpics from './epics';
import * as authSelectors from './selectors';
export { authTypes, authActions, authEpics, authSelectors };

export default reducer;
